import React from 'react'
import { Skeleton, Typography } from '@mui/material'
import { commify } from 'ethers/lib/utils'
import { BigNumber } from 'ethers'
import { Row } from '@/components/common/Rows'
import { formatNumber } from '@/utils'

const Earned = ({
  loading,
  tokenName,
  userEarned,
  decimal,
  price,
}: {
  loading: boolean
  tokenName: string
  userEarned?: BigNumber
  decimal?: number
  price?: number
}) => {
  return loading ? (
    <Skeleton width={100} height={21} />
  ) : (
    <Row sx={{ alignItems: 'baseline' }}>
      <Typography sx={{ fontSize: '14px', fontWeight: 400 }}>
        {userEarned && typeof decimal === 'number' ? formatNumber(userEarned.toString(), decimal) : '-'} {tokenName}
      </Typography>

      <Typography sx={{ fontSize: '12px', fontWeight: 400, opacity: 0.7, ml: 8 }}>
        ${' '}
        {userEarned && typeof decimal === 'number' && typeof price === 'number'
          ? commify((Number(formatNumber(userEarned.toString(), decimal, { shouldCommify: false })) * price).toFixed(2))
          : '-'}
      </Typography>
    </Row>
  )
}

export default Earned
